import { Controller } from "@hotwired/stimulus"
import "@andypf/json-viewer"

// Connects to data-controller="json-viewer"
export default class extends Controller {
  static targets = ["input", "json"]

  connect() {
    this.setData()
  }

  setData() {
    this.jsonTarget['data'] = this.inputTarget.value || ' '
  }
}
